
import { useQuery,useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';


type UseTermsOptions = {
    slug: any ;
  };
  
  type TermsResponse = {
    businessInfo: any;
  };
  export const getTermsDetails = ({
    slug,
  }: UseTermsOptions): Promise<TermsResponse> => {
    return axios.get(`${slug}/terms`);
  };
  
  type useUpdateTermsDetails = {
    config?: MutationConfig<typeof getTermsDetails>;
  };
  
  export const useGetTermsDetails = ({ config }: useUpdateTermsDetails = {}) => {
    return useMutation({
      ...config,
      mutationFn: getTermsDetails,
    });
  };